import { render, staticRenderFns } from "./ErrorImage.vue?vue&type=template&id=1dca16c9&"
import script from "./ErrorImage.vue?vue&type=script&lang=js&"
export * from "./ErrorImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports